import { forwardRef, ReactNode } from 'react'
import SlickSlider, { Settings } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import './styles.scss'

interface Props extends Settings {
  children: ReactNode
}

const CustomSlider: any = SlickSlider

// Обертка над https://github.com/akiran/react-slick
export const Slider = forwardRef(({ children, ...rest }: Props, ref) => (
  <CustomSlider {...rest} ref={ref}>
    {children}
  </CustomSlider>
))
